import React from "react";
import { X } from "lucide-react";
import { StatusBadge } from "./ui-kit";

export function ShelfLifeResultBadge({ needsValidation }) {
  return needsValidation
    ? <StatusBadge status="giallo">Necessita validazione tecnica</StatusBadge>
    : <StatusBadge status="verde">Nessuna validazione richiesta</StatusBadge>;
}

export function ShelfLifeWhyDrawer({ assessment, onClose }) {
  if (!assessment) return null;
  const { reasoning, result } = assessment;
  return (
    <div className="fixed inset-0 z-[100] flex items-start justify-center bg-navy/60 p-4 backdrop-blur-sm overflow-y-auto" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="relative mt-6 w-full max-w-2xl rounded-2xl border border-hairline bg-white p-6 shadow-2xl sm:p-8">
        <button type="button" onClick={onClose} className="absolute right-3 top-3 grid h-11 w-11 place-items-center rounded-full text-slate-500 hover:bg-slate-100" aria-label="Chiudi"><X className="h-5 w-5" /></button>
        <h2 className="pr-10 font-heading text-xl font-bold text-navy">Perché questa shelf life?</h2>
        <p className="mt-1 text-sm text-slate-500">{assessment.product_name_snapshot} — {result.shelf_life_days ?? "n.d."} giorni, {result.evidence_level_label}</p>
        <div className="mt-4 space-y-2">
          {(reasoning.reasons || []).map((r, i) => (
            <div key={i} className="rounded-lg bg-slate-50 px-3 py-2 text-sm text-navy">{r}</div>
          ))}
        </div>
        <div className="mt-5 grid grid-cols-2 gap-3 text-sm sm:grid-cols-4">
          <div className="rounded-lg border border-hairline p-2 text-center"><div className="text-slate-400 text-xs">Specificità</div><div className="font-semibold text-navy">{reasoning.specificity?.score}/{reasoning.specificity?.max}</div></div>
          <div className="rounded-lg border border-hairline p-2 text-center"><div className="text-slate-400 text-xs">Evidenza</div><div className="font-semibold text-navy">{reasoning.confidence_breakdown?.evidence_component}</div></div>
          <div className="rounded-lg border border-hairline p-2 text-center"><div className="text-slate-400 text-xs">Completezza dati</div><div className="font-semibold text-navy">{reasoning.confidence_breakdown?.completeness_bonus}</div></div>
          <div className="rounded-lg border border-hairline p-2 text-center"><div className="text-slate-400 text-xs">Penalità</div><div className="font-semibold text-navy">-{reasoning.confidence_breakdown?.extrapolation_penalty}</div></div>
        </div>
        {reasoning.regulatory_references?.length > 0 && (
          <div className="mt-5">
            <div className="mb-1.5 text-xs font-semibold uppercase tracking-wider text-slate-500">Riferimenti normativi</div>
            <ul className="space-y-1 text-sm text-navy">
              {reasoning.regulatory_references.map((r, i) => (
                <li key={i}><strong>{r.law}</strong>{r.article ? ` — ${r.article}` : ""}{r.note ? `: ${r.note}` : ""}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}
